import { AgChartProps, AgCharts } from 'ag-charts-react';
import { useTranslation } from 'react-i18next';
import { formatToShortCst } from '../../../../utils/formatToShortCst';
import { DeviceData } from '../../../../types/DeviceData';

interface SummitCompressorChartProps {
  deviceData: DeviceData[];
}

export default function SummitCompressorCharts({ deviceData }: SummitCompressorChartProps) {
  const { t } = useTranslation();

  const formatedData = () =>
    deviceData.map(item => {
      return {
        ...item,
        createdAt: formatToShortCst(item.createdAt || ''),
      };
    });

  const tempChartOptions: AgChartProps['options'] = {
    title: {
      text: t('sites.tempChartTitle'),
    },
    data: formatedData(),
    series: [
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.t1F',
        yName: t('sites.suctionTemp'),
        marker: {
          enabled: false,
        },
      },
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.t2F',
        yName: t('sites.dischargeTemp'),
        marker: {
          enabled: false,
        },
      },
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.t3F',
        yName: t('monitors.liquidLineTemp'),
        marker: {
          enabled: false,
        },
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        reverse: true,
        label: {
          enabled: false,
        },
      },

      {
        type: 'number',
        position: 'left',
        title: {
          text: t('sites.temperature'),
        },
      },
    ],
  };

  const pressureChartOptions: AgChartProps['options'] = {
    title: {
      text: t('sites.pressureChartTitle'),
    },
    data: deviceData,
    series: [
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.p1Psi',
        yName: t('sites.suctionPressure'),
        marker: {
          enabled: false,
        },
      },
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.p2Psi',
        yName: t('sites.liquidLinePressure'),
        marker: {
          enabled: false,
        },
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        reverse: true,
        label: {
          enabled: false,
        },
      },

      {
        type: 'number',
        position: 'left',
        title: {
          text: t('sites.pressure'),
        },
      },
    ],
  };

  const ampChartOptions: AgChartProps['options'] = {
    title: {
      text: t('sites.ampsChartTitle'),
    },
    data: deviceData,
    series: [
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.l1Arms',
        yName: t('sites.compressorAmps'),
        marker: {
          enabled: false,
        },
      },
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.l2Arms',
        yName: t('sites.fanAmps'),
        marker: {
          enabled: false,
        },
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        reverse: true,
        label: {
          rotation: -45,
          minSpacing: 5,
          enabled: false,
        },
      },

      {
        type: 'number',
        position: 'left',
        title: {
          text: t('sites.ampsTitle'),
        },
      },
    ],
  };

  return (
    <>
      <AgCharts options={tempChartOptions} />
      <AgCharts options={pressureChartOptions} />
      <AgCharts options={ampChartOptions} />
    </>
  );
}
